var ErrorCode;
(function (ErrorCode) {
    ErrorCode["NETWORK_ERROR"] = "ERR_NETWORK";
})(ErrorCode || (ErrorCode = {}));
export default ErrorCode;
